import styled from 'styled-components';
import { blockQuotes, pullQuotes, longQuotes } from 'styles/quotes';
import { headers } from 'styles/headers';
import { images } from 'styles/images';
import { breakpoint } from 'styles/globals';
import { paragraphs } from 'styles/paragraphs';
import { Theme, getBodyStyle, getColor } from 'styles/theme';

export const LongformBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media (${breakpoint.mdMin}) {
    flex-direction: row;
  }
`;

export const LongformSocialContainer = styled.div`
  margin-bottom: 16px;
  margin-top: 16px;
  text-align: center;

  @media (${breakpoint.mdMin}) {
    margin-bottom: 0px;
    min-width: calc((100%/12) * 1);
    text-align: right;
  }

  @media (${breakpoint.xlMin}) {
    margin-right: 48px;
    min-width: calc(((100%/12) * 1) - 24px);
  }

  @media (${breakpoint.xxlMin}) {
    margin-right: 48px;
    min-width: calc(((100%/12) * 2) - 40px);
  }
`;

export const LongformBodyContainer = styled.div`
  margin-left: 16px;
  margin-right: 16px;
  
  @media (${breakpoint.mdMin}) {
    margin-left: 24px;
    width: calc(((100%/12) * 10) - 48px);
  }

  @media (${breakpoint.xlMin}) {
    margin-left: calc(((100%/12) * 1) - 48px);
    margin-right: auto;
    width: calc((100%/12) * 7);
  }

  @media (${breakpoint.xxlMin}) {
    max-width: 620px;
  }
`;

export const LongformContentContainer = styled.div<{ theme: Theme }>`
  ${paragraphs};
  ${headers};
  ${images};
  ${blockQuotes};
  ${pullQuotes};
  ${longQuotes};

  ${getBodyStyle('georgia', { default: 'medium' })};
  margin: auto;
  margin-top: 16px;

  @media (${breakpoint.smMin}) {
    .table-container {
      overflow: scroll;
    }
  }

  a {
    color: ${getColor('textLink')};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    &:active {
      color: ${getColor('neutralBlack')};
      text-decoration: none;
    }
  }

  > * {
    &:first-of-type {
      margin-top: 0px;
    }
  }

  h1 {
    line-height: normal;
  }

  .vodvideocontainer {
    iframe {
      aspect-ratio: 16 / 9;
    }
  }

  figure[class*="wp-block-embed-youtube"] {
    div.wp-block-embed__wrapper {
      aspect-ratio: 16 / 9;
      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
`;
